'use client';

/**
 * Mounts PostHog app-wide from the root layout. Initialization is gated
 * inside initPostHog (project key present + trackable hostname), so local
 * development never loads it. Renders nothing.
 *
 * Identification, group assignment, and session-recording start/stop are
 * session-driven and live in PostHogIdentity, which must sit inside the
 * next-auth SessionProvider; this component only boots the library.
 */

import { useEffect } from 'react';
import { initPostHog } from '@/lib/analytics/posthog';

export function PostHogProvider() {
  useEffect(() => {
    initPostHog();
  }, []);

  return null;
}
